import React, { useState } from "react";

import "../all css/newsupdatepage.css";
import "../all css/newsupdatetabs.css";
import { useNavigate } from "react-router-dom";

const logo_dwec = require("../../assets/dwec_logo.png");
const heading_img = require("../../assets/heading_news.png");

const video_hero_section = require("../../assets/hero_vdo.mp4");

function AllNewspart(props) {
  const navigate = useNavigate();
  const renderFirstContainer =
    props.todayToggleState.firstHeadingNewsContent.map((perContent) => {
      return (
        <div className="heading_img_main_part_container" key={Math.random()}>
          <div className="img_heading_container">
            <img
              src={perContent.headingImg}
              alt="heading_img"
              className="img_heading_self"
            />
          </div>
          <div className="content_heading_container">
            <p className="heading_news_update_title">
              {perContent.headingTitle}
              {/* {perContent.headingTitle.length > 10
                ? perContent.headingTitle.substring(0, 10) + "... "
                : perContent.headingTitle} */}
            </p>
            <p className="extra_content_new_update">
              {perContent.headingExtraContent.length > 300
                ? perContent.headingExtraContent.substring(0, 300) + "... "
                : perContent.headingExtraContent}{" "}
              <a
                href="NewsDetails"
                className="news_update_read_more"
                onClick={() =>
                  navigate("/NewsDetails", {
                    state: {
                      newsTitle: perContent.headingTitle,
                      newsCoverImg: perContent.headingImg,
                      dateNews: perContent.headingDate,
                      longDescriptionNews: perContent.headingExtraContent,
                    },
                  })
                }
              >
                ... Read more
              </a>
            </p>

            <div className="red_box_time_date_container">
              <div className="red_box" />
              <p className="red_box_time_content_text">
                {perContent.headingDate}
              </p>
            </div>

            <hr className="news_update_line_heading" />
          </div>
        </div>
      );
    });

  const renderHighlightedContent =
    props.todayToggleState.highlightedRedNewsContent.map((perHighlight) => {
      return (
        <div className="highlighted_news_container" key={Math.random()}>
          <p className="highlight_text">
            {perHighlight.highlightedTitle.length > 30
              ? perHighlight.highlightedTitle.substring(0, 30) + "... "
              : perHighlight.highlightedTitle}
          </p>
          <p className="highlight_extra_content_container">
            {perHighlight.highlightedExtraContent.length > 200
              ? perHighlight.highlightedExtraContent.substring(0, 200) + "... "
              : perHighlight.highlightedExtraContent}{" "}
            <a
              href="NewsDetails"
              className="news_update_read_more"
              onClick={() =>
                navigate("/NewsDetails", {
                  state: {
                    newsTitle: perHighlight.highlightedTitle,

                    dateNews: perHighlight.datehighlightedText,
                    longDescriptionNews: perHighlight.highlightedExtraContent,
                  },
                })
              }
            >
              ... Read more
            </a>
          </p>
          <div className="red_box_time_date_container">
            <div className="red_box" />
            <p className="red_box_time_content_text">
              {perHighlight.datehighlightedText}
            </p>
          </div>
        </div>
      );
    });
  return (
    <>
      <div className="news_update_main_under_page_container">
        <div className="news_update_mainheader_news_update_page_container">
          {/* <div className="news_update_logo_container">
            <img src={logo_dwec} alt="dwec_logo" className="dwec_logo" />
          </div> */}

          {/* <p className="header_date_text_news_update">24th April 2022</p> */}
        </div>
        <hr />
        <div className="news_update_body_section_container">
          <div className="two_part_of_news_update_container">
            <div className="first_part_news_update_container">
              {renderFirstContainer}
            </div>
            <div className="sec_part_news_update_container">
              <div className="content_img_news_update_container">
                <p className="title_of_content_news_text">
                  {/* {props.todayToggleState?.authorNewsContent?.authorHeading} */}
                  {props.todayToggleState?.authorNewsContent?.authorHeading
                    .length > 200
                    ? props.todayToggleState?.authorNewsContent?.authorHeading.substring(
                        0,
                        200
                      ) + "... "
                    : props.todayToggleState?.authorNewsContent?.authorHeading}
                </p>

                <hr />
                <div className="content_img_author_text_news_update_container">
                  <div className="content_news_updat_img_container">
                    <p className="extra_content_news_update_text">
                      {/* <span className="strong_keyword">A</span> Sed ut */}
                      {/* {
                        props.todayToggleState?.authorNewsContent
                          ?.authorDescription
                      } */}

                      {props.todayToggleState?.authorNewsContent
                        ?.authorDescription.length > 500
                        ? props.todayToggleState?.authorNewsContent?.authorDescription.substring(
                            0,
                            500
                          ) + "... "
                        : props.todayToggleState?.authorNewsContent
                            ?.authorDescription}
                      <a
                        href="NewsDetails"
                        className="news_update_read_more"
                        onClick={() =>
                          navigate("/NewsDetails", {
                            state: {
                              newsTitle:
                                props.todayToggleState?.authorNewsContent
                                  ?.authorHeading,
                              newsCoverImg:
                                props.todayToggleState?.authorNewsContent
                                  ?.authorNewsImg,
                              dateNews:
                                props.todayToggleState?.authorNewsContent
                                  ?.authorDate,
                              longDescriptionNews:
                                props.todayToggleState?.authorNewsContent
                                  ?.authorDescription,
                            },
                          })
                        }
                      >
                        ... Read more
                      </a>
                    </p>

                    <p className="author_name_text">
                      {props.todayToggleState?.authorNewsContent?.authorName}
                    </p>
                  </div>
                  <div className="img_container_time">
                    <div className="image_container">
                      <img
                        src={
                          props.todayToggleState?.authorNewsContent
                            ?.authorNewsImg
                        }
                        alt="heading_img"
                        className="news_img"
                      />
                    </div>
                    <div className="red_box_time_date_container">
                      <div className="red_box" />
                      <p className="red_box_time_content_text">
                        {props.todayToggleState?.authorNewsContent?.authorDate}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />

              {/* four heading container */}
              <div className="highlight_flex_container">
                {renderHighlightedContent}
              </div>
              <hr />

              {/* another container */}

              <div className="another_heading_img_content_container">
                <div className="flex_another_img_container">
                  <div className="heading_img_another_container">
                    <img
                      src={
                        props.todayToggleState?.commonNewsContent?.commonNewsImg
                      }
                      alt="heading_img"
                      className="heading_img"
                    />
                  </div>
                  <div className="content_heading_title_another_contianer">
                    <p className="heading_news_update_title">
                      {props.todayToggleState?.commonNewsContent
                        ?.commonNewsHeading.length > 200
                        ? props.todayToggleState?.commonNewsContent?.commonNewsHeading.substring(
                            0,
                            200
                          ) + "... "
                        : props.todayToggleState?.commonNewsContent
                            ?.commonNewsHeading}
                    </p>
                    <p className="extra_content_news_update_text">
                      {props.todayToggleState?.commonNewsContent
                        ?.commonNewsDescription.length > 500
                        ? props.todayToggleState?.commonNewsContent?.commonNewsDescription.substring(
                            0,
                            500
                          ) + "... "
                        : props.todayToggleState?.commonNewsContent
                            ?.commonNewsDescription}

                      <a
                        href="NewsDetails"
                        className="news_update_read_more"
                        onClick={() =>
                          navigate("/NewsDetails", {
                            state: {
                              newsTitle:
                                props.todayToggleState?.commonNewsContent
                                  ?.commonNewsHeading,
                              newsCoverImg:
                                props.todayToggleState?.commonNewsContent
                                  ?.commonNewsImg,
                              dateNews:
                                props.todayToggleState?.commonNewsContent
                                  ?.commonNewsDate,
                              longDescriptionNews:
                                props.todayToggleState?.commonNewsContent
                                  ?.commonNewsDescription,
                            },
                          })
                        }
                      >
                        ... Read more
                      </a>
                    </p>
                    <div className="red_box_time_date_container">
                      <div className="red_box" />
                      <p className="red_box_time_content_text">
                        {
                          props.todayToggleState?.commonNewsContent
                            ?.commonNewsDate
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              {/* video another container */}

              <div className="another_heading_img_content_container">
                <div className="flex_another_img_container1">
                  <div className="vdo_img_another_container">
                    <video
                      controls
                      autoPlay
                      playsInline
                      preload="auto"
                      className="video_hero_section2"
                    >
                      <source
                        src={props.todayToggleState?.videoNewsContent?.video}
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  <div className="video_heading_container_another">
                    <p className="heading_news_update_title">
                      {props.todayToggleState?.videoNewsContent?.videoHeading}
                    </p>
                    <p className="extra_content_news_update_text">
                      {
                        props.todayToggleState?.videoNewsContent
                          ?.videoDescription
                      }
                      {/* <a
                        href="NewsDetails"
                        className="news_update_read_more"
                        onClick={() =>
                          navigate("/NewsDetails", {
                            state: props.todayToggleState?.videoNewsContent,
                          })
                        }
                      >
                        ... Read more
                      </a> */}
                    </p>
                    <div className="red_box_time_date_container">
                      <div className="red_box" />
                      <p className="red_box_time_content_text">
                        {props.todayToggleState?.videoNewsContent?.videoDate}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllNewspart;
